import gql from "graphql-tag";

export default gql`
  query {
    inventoryLocations {
      id
      name
      code
    }
  }
`;
